import mime from 'mime';
import { amplifyConfig } from '@/utils/environment';
import { Storage } from 'aws-amplify';
import { v4 as uuidv4 } from 'uuid';

export const BASE_URL = `https://s3.amazonaws.com/${amplifyConfig.Storage.AWSS3.bucket}`;

export enum PREFIXES {
  Uploads = 'uploads/',
}

export enum UPLOAD_PREFIXES {
  Chats = 'chats',
  CreditRequests = 'credit_requests',
  MenuImages = 'menu_images',
  Orders = 'orders',
}

export interface ImageData {
  blob: Blob;
  uri: string;
}

export const getImageDataFromURI = async (uri: string): Promise<ImageData> => {
  return await new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.onload = () => {
      resolve({
        blob: xhr.response as Blob,
        uri,
      });
    };
    xhr.onerror = () => {
      reject(new Error('Image request failed'));
    };
    xhr.responseType = 'blob';
    xhr.open('GET', uri, true);
    xhr.send();
  });
};

const uploadImage = async (
  image: ImageData,
  // Amplify doesn't have types defined for `Storage.put` options
  { prefix = '', ...options }: { [key: string]: unknown; prefix?: string },
) => {
  const contentType = image.blob.type;
  const extension = mime.getExtension(contentType);
  return await Storage.put(`${prefix}${uuidv4()}.${extension}`, image.blob, {
    ...options,
    contentType,
  });
};

// TODO: fix and document s3 permissions
export const uploadPublicImage = async (
  objectUUID: string,
  imageURI: string,
  prefix: UPLOAD_PREFIXES,
) => {
  const image = await getImageDataFromURI(imageURI);

  // @ts-ignore - key is defined on the returned object
  const { key } = await uploadImage(image, {
    customPrefix: {
      public: PREFIXES.Uploads,
    },
    level: 'public',
    prefix: `${prefix}/${objectUUID}/`,
  });

  return `${BASE_URL}/${PREFIXES.Uploads}${key}`;
};
